import styles from './ChoiceCards.module.css';
import { useLocale } from '../../../hooks/useLocale';
import { TChoice } from '../logic/types';

type TProps = {
  choices: TChoice[];
  value: string | undefined;
  onSelect?: (value: string) => void;
  groupLabel: string;
  disabled?: boolean;
};

export const ChoiceCards = ({
  choices,
  value,
  onSelect,
  groupLabel,
  disabled,
}: TProps) => {
  const { i18n } = useLocale();
  return (
    <fieldset
      role="radiogroup"
      aria-label={groupLabel}
      className={styles.group}
      disabled={disabled}
    >
      {choices.map((choice) => {
        const checked = value === choice.value;
        return (
          <label
            key={choice.value}
            className={`${styles.card} ${checked ? styles.cardChecked : ''} ${
              disabled ? styles.cardDisabled : ''
            }`}
          >
            <span className={styles.label}>{i18n._(choice.label)}</span>
            <input
              type="radio"
              className={styles.input}
              name={groupLabel}
              value={choice.value}
              checked={checked}
              disabled={disabled}
              onChange={() => onSelect?.(choice.value)}
            />
            <span className={styles.control} aria-hidden="true" />
          </label>
        );
      })}
    </fieldset>
  );
};
